import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
import { OfferCard } from './OfferCard';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 12,
    minutes: 45,
    seconds: 29
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-12 sm:py-24 bg-slate-50" data-id="element-172">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-173">
        <div className="mx-auto max-w-4xl" data-id="element-174">
          <div className="text-center mb-8 sm:mb-12" data-id="element-175">
            <div className="inline-flex items-center justify-center gap-1.5 sm:gap-2 rounded-full bg-rose-100 px-3 sm:px-4 py-1 sm:py-1.5 mb-4 sm:mb-6" data-id="element-176">
              <Zap className="h-4 w-4 sm:h-5 sm:w-5 text-rose-600" data-id="element-177" />
              <span className="text-xs sm:text-sm font-bold text-rose-600 uppercase tracking-wider" data-id="element-178">
                Launch Price Ends Soon
              </span>
            </div>

            <div className="flex justify-center gap-2 sm:gap-4 text-2xl sm:text-3xl font-bold text-slate-900 font-display" data-id="element-179">
              <div className="flex flex-col items-center" data-id="element-180">
                <span className="bg-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg shadow-sm ring-1 ring-slate-200 w-12 sm:w-16 text-center" data-id="element-181">
                  {String(timeLeft.hours).padStart(2, '0')}
                </span>
                <span className="text-[10px] sm:text-xs text-slate-500 mt-1.5 sm:mt-2 uppercase tracking-wider font-sans" data-id="element-182">
                  Hours
                </span>
              </div>
              <span className="py-1.5 sm:py-2" data-id="element-183">:</span>
              <div className="flex flex-col items-center" data-id="element-184">
                <span className="bg-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg shadow-sm ring-1 ring-slate-200 w-12 sm:w-16 text-center" data-id="element-185">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </span>
                <span className="text-[10px] sm:text-xs text-slate-500 mt-1.5 sm:mt-2 uppercase tracking-wider font-sans" data-id="element-186">
                  Mins
                </span>
              </div>
              <span className="py-1.5 sm:py-2" data-id="element-187">:</span>
              <div className="flex flex-col items-center" data-id="element-188">
                <span className="bg-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg shadow-sm ring-1 ring-slate-200 w-12 sm:w-16 text-center" data-id="element-189">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
                <span className="text-[10px] sm:text-xs text-slate-500 mt-1.5 sm:mt-2 uppercase tracking-wider font-sans" data-id="element-190">
                  Secs
                </span>
              </div>
            </div>
          </div>

          <OfferCard variant="full" data-id="element-191" />
        </div>
      </div>
    </section>;
}